export default "__VITE_ASSET__28f1a849__"